import { render, staticRenderFns } from "./customer-dashboard.vue?vue&type=template&id=788cfb4a"
import script from "./customer-dashboard.vue?vue&type=script&lang=js"
export * from "./customer-dashboard.vue?vue&type=script&lang=js"
import style0 from "./customer-dashboard.vue?vue&type=style&index=0&id=788cfb4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports